"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NORMAL_NODE_SIZE = 2;
exports.LEAF_NODE_SIZE = 1;
// https://github.com/ProseMirror/prosemirror-schema-basic/blob/master/src/schema-basic.js
exports.NODE_NAME = {
    P: 'paragraph',
    LIST: 'list_item',
    QUOTE: 'block_quote',
    O_LIST: 'ordered_list',
    B_LIST: 'bullet_list',
    PARAGRAPH: 'paragraph',
    BLOCKQUOTE: 'blockquote',
    BOOKMARK: 'bookmark',
    BULLET_LIST: 'bullet_list',
    CODE_BLOCK: 'code_block',
    DOC: 'doc',
    HARD_BREAK: 'hard_break',
    HEADER: 'header',
    HORIZONTAL_RULE: 'horizontal_rule',
    IMAGE: 'image',
    LINK: 'link',
    LIST_ITEM: 'list_item',
    MATH: 'math',
    ORDERED_LIST: 'ordered_list',
    TABLE: 'table',
    TABLE_CELL: 'table_cell',
    TABLE_HEADER: 'table_header',
    TABLE_ROW: 'table_row',
    TEXT: 'text',
    UNDERLINE: 'underline'
};
//# sourceMappingURL=const.js.map